import { render, staticRenderFns } from "./newOaWorkflowUndo.vue?vue&type=template&id=a2629244&scoped=true"
import script from "./newOaWorkflowUndo.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowUndo.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowUndo.vue?vue&type=style&index=0&id=a2629244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2629244",
  null
  
)

export default component.exports